import React, { useEffect, useState } from "react";
import { formatInTimeZone } from "date-fns-tz";

interface CountdownTimerProps {
  webinarStartTime: Date;
  webinarDuration: number; // in milliseconds
  timeZone: string;
  onStart: () => void;
  onEnd: () => void;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  webinarStartTime,
  webinarDuration,
  timeZone,
  onStart,
  onEnd,
}) => {
  const [timeUntilStart, setTimeUntilStart] = useState<string>("");
  const [timeUntilEnd, setTimeUntilEnd] = useState<string>("");
  const [isWebinarStarted, setIsWebinarStarted] = useState(false);

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const nowInET = new Date(
        formatInTimeZone(now, timeZone, "yyyy-MM-dd HH:mm:ss")
      );

      const timeToStart = webinarStartTime.getTime() - nowInET.getTime();
      const timeToEnd =
        webinarStartTime.getTime() + webinarDuration - nowInET.getTime();

      if (timeToStart > 0) {
        setTimeUntilStart(formatTimeWithShortcuts(timeToStart));
        setTimeUntilEnd("");
        setIsWebinarStarted(false);
      } else if (timeToEnd > 0) {
        setTimeUntilStart("Webinar Started");
        setTimeUntilEnd(formatTimeWithShortcuts(timeToEnd));
        setIsWebinarStarted(true);
        onStart(); // Trigger callback when webinar starts
      } else {
        setTimeUntilStart("Webinar Ended");
        setTimeUntilEnd("");
        setIsWebinarStarted(false);
        onEnd(); // Trigger callback when webinar ends
      }
    };

    updateCountdown(); // Call immediately to avoid initial delay
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [webinarStartTime, webinarDuration, timeZone, onStart, onEnd]);

  // Helper function to format time
  const formatTimeWithShortcuts = (milliseconds: number) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let result = "";
    if (hours > 0) result += `${hours}h `;
    if (minutes > 0) result += `${minutes}m `;
    result += `${seconds}s`;

    return result;
  };

  return (
    <div className="event-timedata">
      {!isWebinarStarted && (
        <>
          <p>Starts In: {timeUntilStart}</p>
        </>
      )}
      {isWebinarStarted && <p>Ends In: {timeUntilEnd}</p>}
    </div>
  );
};

export default CountdownTimer;